<!-- Content -->
<div class="content container-fluid">
  <!-- Page Header -->
  <header class="page-header">
    <nav attr.aria-label="{{ 'wcag.breadcrumb' | translate }}">
      <ol class="breadcrumb">
        <breadcrumb></breadcrumb>
        &nbsp; / &nbsp;
        <li class="breadcrumb-item active">Index</li>
      </ol>
    </nav>

    <div class="page-header-grid grid-sm">
      <h1 class="page-header-title">
        {{ 'courseModule.courses' | translate }}
      </h1>

      <div
        *ngIf="courseModuleConfig.fullAccess"
        [canSee]="[accessRights.Course_write]"
      >
        <button
          type="button"
          data-test-id="create-course-button"
          class="btn btn-primary"
          (click)="onClickCreate()"
        >
          {{ 'general.create' | translate }}
        </button>
      </div>
    </div>
  </header>

  <!-- Nav -->

  <div class="d-flex">
    <dms-switch
      [defaultActiveItem]="defaultTab"
      [textItem1]="'general.active'"
      [textItem2]="'general.inactive'"
      [responseItem1]="true"
      [responseItem2]="false"
      (onEmitItem1)="form.controls['isActive'].patchValue($event)"
      (onEmitItem2)="form.controls['isActive'].patchValue($event)"
    >
    </dms-switch>
  </div>

  <!-- End Nav -->
  <dms-table
    [activeTab]="actualTab"
    [resetSearch$]="refreshData$"
    [isLoading]="isLoading$ | async"
    [showTotal]="true"
    [tableType]="'courses'"
    [bulkActions]="[BulkAction.COPY]"
    (onBulkAction)="onBulkAction($event)"
    (onClickRow)="onClickRow($event)"
    (onTab)="onTabSelected($event)"
  >
  </dms-table>
</div>
